<template>
    <div class="short-message">
        <div class="short-message-info">
            <div class="short-message-title">短信服务介绍</div>
            <p>用户成功下单并支付后会自动收到一条购课成功短信，用户点击短信可直接跳转小程序看课</p>
        </div>
        <div class="short-message-balance-con">
            <div class="short-message-title" style="margin:18px 0">余额管理</div>
            <div class="short-message-balance">
                <div class="short-message-balance-li">
                    <span class="label">已使用（条）</span>
                    <span class="value">{{smsTotalObj.sms_total - smsTotalObj.sms_counts}}</span>
                </div>
                <div class="short-message-balance-li">
                    <span class="label">剩余（条）</span>
                    <span class="value">{{smsTotalObj.sms_counts}}</span>
                </div>
            </div>
        </div>
        <div class="short-message-buy-con">
            <div class="short-message-title" style="margin:18px 0">短信包购买</div>
            <div class="short-message-buy">
                <div class="short-message-buy-header">
                    <span>购买须知</span>
                    <p>本短信服务通道为第三方平台提供，由于用户网络及信号问题造成的无法收到短信，本平台将不负责</p>
                </div>
                <tabsList :data="smsactivityList" v-model="tabs" :valueIsRenderFlag="true" :propsObj="{'label': {value: 'price', label: '元'}, value: {value: 'id'}, count: {value: 'count', label: '条'}}" :countNum.sync="countNum"></tabsList>
                <template v-if="tabs">
                    <div class="payment">
                        <span>需支付：</span>
                        <span>¥{{countNum}}</span>
                    </div>
                    <tabsList :data="payTypeList" v-model="payType"></tabsList>
                    <el-button type="primary" style="margin-top: 24px" :disabled="!payType" @click="payFun">确认购买</el-button>
                </template>
                <p class="short-message-history" @click="watchHistory">购买记录></p>
            </div>
        </div>
        <el-dialog
            :visible.sync="dialogVisible"
            width="600px"
            align="center"
            >
            <span slot="title">
                {{payType && payTypeList.find(item => item.value === payType).label}}
            </span>
            <div v-loading="isLoading ==='noFullScreen'">
                <img :src="payInfo.url" alt="" style="width: 200px;height: 200px"/>
            </div>
            <span slot="footer" class="dialog-footer">
            </span>
        </el-dialog>
		
		<el-dialog
		  title="提示"
		  :visible.sync="dialogVisibledev"
		  width="30%"
		  >
		  <span>支付功能正在开发调试中</span>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisibledev = false">取 消</el-button>
		    <el-button type="primary" @click="dialogVisibledev = false">确 定</el-button>
		  </span>
		</el-dialog>
		
    </div>
</template>
<script>
import tabsList from './tabs/tabs.jsx'
import { mapState, mapActions } from 'vuex'
export default {
    data() {
        return {
            smsactivityList: [],
            tabs: '',
            countNum: '',
            payType: '1',
            payTypeList: [
                 {
                    label: '微信支付',
                    value: '1'
                },
                // {
                //     label: '支付宝支付',
                //     value: '2'
                // }
               
            ],
            smsTotalObj: {
                sms_total: 0,
                sms_counts: 0
            },
            dialogVisible: false,
            payInfo: {
                url: '',
                out_trade_no: ''
            },
			dialogVisibledev: false
        }
    },
    components: {
        tabsList
    },
    computed: {
        ...mapState(['isLoading'])
    },
    created() {
        this.getSmsindex()
        this.getSmsactivity()
        this.$watch('dialogVisible', (news) => {
            console.log(news, '[[[')
        })
    },
    methods: {
        ...mapActions('message', ['smsindex', 'payPrepayurl', 'payCheckorder', 'payCheckorder', 'smsactivity']),
        async getSmsindex() {
            let res = await this.smsindex()
            this.smsTotalObj = {
                sms_total: res.sms_total,
                sms_counts: res.sms_counts
            }
        },
        async getPayPrepayurl() {
            let res = await this.payPrepayurl({ sms_activity: this.tabs })
            this.payInfo = {
                url: res.orderInfo.wx_url,
                out_trade_no: res.orderInfo.out_order_no
            }
        },
        async payFun() {
            this.dialogVisible = true
            await this.getPayPrepayurl()
            this.getPayOrderStatus()
        },
        async getPayOrderStatus() {
            if(this.dialogVisible) {
                try {
                    let res = await this.payCheckorder({out_trade_no: this.payInfo.out_trade_no})
                    if(res.status === 1) {
                        this.dialogVisible = false
                        this.payType = '1'
                        if(this.smsactivityList.length) {
                            this.countNum = this.smsactivityList[0].price
                            this.tabs = this.smsactivityList[0].id
                        }
                        this.getSmsindex()
                    }
                    setTimeout(() => {
                        this.getPayOrderStatus()
                    }, 2000)
                } catch (error) {
                    
                }
            } 
        },
        async getSmsactivity() {
            let res = await this.smsactivity()
            this.smsactivityList = res
            if(res.length) {
                this.countNum = res[0].price
                this.tabs = res[0].id
            }
        },
        watchHistory() {
            this.$router.push(this.staticPath + 'shortMessageHistory')
        }
    }
}
</script>
<style lang="less" scoped>
    .short-message {
        .common-css {
            border: 1px solid #eef0f7;
            padding: 24px;
            border-radius: 6px;
        }
        .short-message-title {
            color: #333;
            font-size: 16px;
            font-weight: 600;
        }
        .short-message-info {
            &:extend(.short-message .common-css);
            >p {
                font-size: 14px;
                color: #999;
                margin-top: 12px;
            }
        }
        .short-message-balance-con {
            .short-message-balance {
                &:extend(.short-message .common-css);
                display: flex;
            }
            .short-message-balance-li {
                display: flex;
                flex-direction: column;
                &:not(:first-child) {
                    margin-left: 40px;
                }
                .label {
                    color: #999;
                }
                .value {
                    margin-top: 18px;
                    font-weight: 600;
                }
            }
        }
        .short-message-buy {
            &:extend(.short-message .common-css);
            .short-message-buy-header {
                display: flex;
                align-content: center;
                margin-bottom: 18px;
                span {
                    font-weight: 600;
                    font-size: 14px;
                }
                p {
                    color: #999;
                    margin-left: 12px;
                    font-size: 14px;
                }
            }
        }
        .payment {
            margin-top: 24px;
            span {
                &:first-child {
                    font-size: 14px;
                }
                &:last-child {
                    font-size: 14px;
                    color: red;
                }
            }
        }
    }
    .short-message-history {
        margin-top: 12px;
        font-size: 14px;
        cursor: pointer;
        color: #409EFF;
    }
</style>